export const TYPES_EXCEPTION_MARGE = [
  'AVOIR_TOTAL', 'AVOIR_PARTIEL', 'RETOUR_MARCHANDISE', 'PLUSIEURS_FACTURES_AMBIGUES',
  'PLUSIEURS_AVOIRS', 'AVOIR_SANS_FACTURE_UNIQUE', 'MARGE_INCOHERENTE',
  'MARGE_ABSENTE', 'HT_NUL', 'COMMANDE_INTROUVABLE', 'AUTRE'
];

export const TAILLES_LOT_MARGE = [25, 50, 100, 'TOUT'];

const EXCEPTIONS_BRUTES = [
  ['C012600021','AJC','F012600063','A012600181','AVOIR_TOTAL',0],
  ['C012600130','RUBAN DU PAYS BEAUJOLAIS DE BAGNOLS','F012600158','A012600159','AVOIR_TOTAL',0],
  ['C012500273','VINDRY PADEL CLUB','F012600144','A012600145','AVOIR_TOTAL',0],
  ['C012600071','AMICALE CLASSE EN 6 MISERIEUX','F012600094','A012600096','AVOIR_TOTAL',0],
  ['C012500239','IRIGNY FUTSAL','F012500234','A012600060','AVOIR_TOTAL',0],
  ['C012500125','LES FAUVETTES DES PIERRES DORÉES','F012600048','A012600049','AVOIR_TOTAL',0],
  ['C012500169','MFR LA PALMA','F012600002','A012600003','AVOIR_TOTAL',0],
  ['C012500130','IRIGNY FUTSAL','F012500193','A012500243','AVOIR_TOTAL',0],
  ['C012500250','AJC ST JULIEN','F012500240','A012500241','AVOIR_TOTAL',0],
  ['C012500226','VINDRY PADEL CLUB','F012500221','A012500225','AVOIR_TOTAL',0],
  ['C012500227','VINDRY PADEL CLUB','F012500222','A012500226','AVOIR_TOTAL',0],
  ['C012500156',"COMMUNAUTE DE COMMUNES DU PAYS DE L'ARBRESLE",'F012500151','A012500157','AVOIR_TOTAL',0],
  ['C012500111','ASA CLOCHEMERLE','F012500118','A012500121','AVOIR_TOTAL',0],
  ['C012500107','AJC ST JULIEN','F012500111','A012500117','AVOIR_TOTAL',0],
  ['C012400194','AB LA GIRAUDIERE','F012500021','A012500023','AVOIR_TOTAL',0],
  ['C012400196','LA BELLE LULU','F012400204','A012400205','AVOIR_TOTAL',0],
  ['C012400175','CONCEPT RENOV','F012400195','A012400196','AVOIR_TOTAL',0],
  ['C012400127','MAIRIE LENTILLY','F012400185','A012400186','AVOIR_TOTAL',0],
  ['C012600080','SAS LES JARDINS FLEURIS','F012600173 ; F012600143','','PLUSIEURS_FACTURES_AMBIGUES',1838.58],
  ['C012600049','A.B BANEINS','F012600130 ; F012600086','','PLUSIEURS_FACTURES_AMBIGUES',3764.50],
  ['C012500220','TENNIS CLUB DU POPEY','F012600064 ; F012600055','','PLUSIEURS_FACTURES_AMBIGUES',1142.40],
  ['C012500222','TENNIS CLUB CHATILLON/CHESSY (T3C)','F012600065 ; F012600057','','PLUSIEURS_FACTURES_AMBIGUES',420],
  ['C012500129','IRIGNY FUTSAL','F012600030 ; F012500192','','PLUSIEURS_FACTURES_AMBIGUES',3276.90],
  ['C012500241','UNION SPORTIVE DES OULLIERES (USO)','F012600037 ; F012500237','','PLUSIEURS_FACTURES_AMBIGUES',901.29],
  ['C012500126','FC DENICE-ARNAS','F012500147 ; F012500140','','PLUSIEURS_FACTURES_AMBIGUES',5232],
  ['C012500039','CLASSE EN 2 DENICE','F012500093 ; F012500054','','PLUSIEURS_FACTURES_AMBIGUES',1872.20],
  ['C012400183','SAS LES JARDINS FLEURIS','F012500048 ; F012500013','','PLUSIEURS_FACTURES_AMBIGUES',30393.76],
  ['C012500029','PAYS DE L’ARBRESLE RUGBY CLUB','F012500045 ; F012500036','','PLUSIEURS_FACTURES_AMBIGUES',559.25],
  ['C012400203','FC SAVIGNY','F012500033 ; F012400220','','PLUSIEURS_FACTURES_AMBIGUES',1304.60],
  ['C012400217','LES FAUVETTES DES PIERRES DORÉES','F012500030 ; F012400225','','PLUSIEURS_FACTURES_AMBIGUES',1508.48],
  ['C012400153','MAISON PEGUET','F012400191 ; F012400171','','PLUSIEURS_FACTURES_AMBIGUES',6409],
  ['C012500047','DJCE DE LYON','F012500114 ; F012500112','A012500116 ; A012500113','PLUSIEURS_AVOIRS',0],
  ['C012300102','LYON MARQUAGE SERVICES','','A012500217','AVOIR_SANS_FACTURE_UNIQUE',-115],
  ['C012400039','FC DENICE-ARNAS','','A012400177','AVOIR_SANS_FACTURE_UNIQUE',-10277.26]
];

export const EXCEPTIONS_MARGE_EXISTANTES = EXCEPTIONS_BRUTES.map(([commande, client, factures, avoirs, typeCas, ttc]) => ({
  commande, client, commercial: 'Adrien', factures, avoirs, typeCas, ht: null, ttc, marge: null,
  decision: commande === 'C012600130' ? 1 : null,
  statut: commande === 'C012600130' ? 'PRISE_EN_COMPTE' : 'A_REVOIR',
  observation: commande === 'C012600130'
    ? 'Facture + avoir total : marge nette certifiée à 0,00 €.'
    : 'Cas complexe issu du registre local : aucune estimation automatique.'
}));

export const ETAT_MARGES_INITIAL = Object.freeze({
  version: 1,
  perimetreAnnees: 2,
  commandesConcernees: 507,
  commandesFacturees: 505,
  commandesPayees: 479,
  commandesAvecAvoir: 21,
  casSimples: 473,
  casComplexes: 34,
  certifiees: 25,
  casSimplesRestants: 448,
  caHtCouvert: 16206.91,
  margeCertifiee: 7961.47,
  derniereCommande: 'C012600160',
  prochaineCommande: 'C012600169',
  statutCollecte: 'PRETE_A_REPRENDRE',
  traiteesLot: 0,
  certifieesLot: 0,
  exceptionsLot: 0,
  tailleLot: 50,
  exceptions: EXCEPTIONS_MARGE_EXISTANTES,
  temoins: [
    { commande: 'C012600220', ht: 87.5, marge: 47.5, taux: 54.29, decision: 1 },
    { commande: 'C012600219', ht: 75, marge: 48.96, taux: 65.28, decision: 1 },
    { commande: 'C012600130', ht: 0, marge: 0, taux: null, decision: 1, cycle: 'FACTURE_AVOIR_TOTAL' }
  ]
});

const texte = (valeur) => String(valeur ?? '').trim();
const dateIso = (valeur) => texte(valeur).slice(0, 10);
const liste = (valeur) => Array.isArray(valeur) ? valeur : valeur ? [valeur] : [];
const arrondi = (valeur) => Math.round((Number(valeur) + Number.EPSILON) * 100) / 100;

const dateLimite = (dateReference, annees) => {
  const reference = new Date(`${dateIso(dateReference)}T12:00:00`);
  reference.setFullYear(reference.getFullYear() - Number(annees || 2));
  return reference.toISOString().slice(0, 10);
};

const mouvementsFinanciers = (commande = {}) => [
  ...liste(commande.factures).map((piece) => ({ ...piece, type: 'FACTURE' })),
  ...liste(commande.avoirs).map((piece) => ({ ...piece, type: 'AVOIR' })),
  ...liste(commande.retours).map((piece) => ({ ...piece, type: 'RETOUR' }))
];

export function empreinteCycleFinancier(commande = {}) {
  return mouvementsFinanciers(commande)
    .map((piece) => [piece.type, texte(piece.numero || piece.id), dateIso(piece.date), Number(piece.ht || 0), Number(piece.ttc || 0)].join('|'))
    .sort()
    .join('¦');
}

export function classifierExceptionMarge(commande = {}) {
  const factures = liste(commande.factures);
  const avoirs = liste(commande.avoirs);
  const retours = liste(commande.retours);
  if (!texte(commande.numero)) return 'COMMANDE_INTROUVABLE';
  if (!factures.length && avoirs.length) return 'AVOIR_SANS_FACTURE_UNIQUE';
  if (factures.length > 1) return 'PLUSIEURS_FACTURES_AMBIGUES';
  if (avoirs.length > 1) return 'PLUSIEURS_AVOIRS';
  if (retours.length) return 'RETOUR_MARCHANDISE';
  if (avoirs.length && avoirs.some((avoir) => Math.abs(Number(avoir.ttc || 0)) < Math.abs(Number(factures[0]?.ttc || 0)))) return 'AVOIR_PARTIEL';
  if (commande.ht == null || commande.marge == null) return 'MARGE_ABSENTE';
  if (Math.abs(Number(commande.ht)) < 0.000001) return 'HT_NUL';
  const tauxCalcule = arrondi(Number(commande.marge) / Number(commande.ht) * 100);
  if (commande.taux != null && Math.abs(tauxCalcule - Number(commande.taux)) >= 0.01) return 'MARGE_INCOHERENTE';
  return null;
}

export function detecterCommandesAMettreAJour(commandes = [], certifications = [], options = {}) {
  const reference = options.dateReference || new Date().toISOString().slice(0, 10);
  const limite = dateLimite(reference, options.perimetreAnnees || 2);
  const indexCertifications = new Map(certifications.map((item) => [texte(item.commande), item]));
  return commandes.flatMap((commande) => {
    const factures = liste(commande.factures);
    if (!factures.length) return [];
    const mouvements = mouvementsFinanciers(commande);
    const dateDernierMouvement = mouvements.map((piece) => dateIso(piece.date)).filter(Boolean).sort().at(-1) || dateIso(commande.date);
    if (!dateDernierMouvement || dateDernierMouvement < limite) return [];
    const empreinte = empreinteCycleFinancier(commande);
    const certification = indexCertifications.get(texte(commande.numero));
    if (certification?.statut === 'CERTIFIE' && certification.empreinte === empreinte) return [];
    const typeException = classifierExceptionMarge(commande);
    return [{ ...commande, dateDernierMouvement, empreinte, typeException, raison: certification ? 'CYCLE_FINANCIER_MODIFIE' : 'MARGE_A_COLLECTER' }];
  }).sort((a, b) => b.dateDernierMouvement.localeCompare(a.dateDernierMouvement) || texte(b.numero).localeCompare(texte(a.numero), 'fr-FR'));
}

export function selectionnerLotMarge(file = [], taille = 50) {
  const maximum = taille === 'TOUT' ? file.length : Math.max(0, Number(taille) || 0);
  return file.slice(0, maximum);
}

export function simulerLotMarge({ restantesSimples = 448, taille = 50, certifiees = 48, exceptions = 2 } = {}) {
  const selectionnees = Math.min(restantesSimples, taille === 'TOUT' ? restantesSimples : Number(taille));
  const certifieesReelles = Math.min(selectionnees, certifiees);
  const exceptionsReelles = Math.min(selectionnees - certifieesReelles, exceptions);
  return {
    selectionnees,
    certifiees: certifieesReelles,
    exceptions: exceptionsReelles,
    restantesSimples: restantesSimples - certifieesReelles - exceptionsReelles,
    restantesLot: selectionnees - certifieesReelles - exceptionsReelles
  };
}

export function appliquerDecisionException(exception = {}, decision, observation = '') {
  const valeur = Number(decision);
  if (![1, 2, 3].includes(valeur)) throw new Error('Décision marge invalide.');
  return {
    ...exception,
    decision: valeur,
    statut: valeur === 1 ? 'PRISE_EN_COMPTE' : valeur === 2 ? 'EXCLUE' : 'A_REVOIR',
    observation: texte(observation || exception.observation),
    decideeLe: new Date().toISOString()
  };
}

export function progressionMarge(etat = ETAT_MARGES_INITIAL) {
  const total = Math.max(0, Number(etat.casSimples || 0));
  const couvertes = Math.max(0, Number(etat.certifiees || 0));
  return {
    commandesCouvertes: couvertes,
    commandesEligibles: total,
    pourcentage: total ? arrondi(couvertes / total * 100) : 0,
    caHtCouvert: Number(etat.caHtCouvert || 0),
    complet: total > 0 && couvertes >= total
  };
}

export async function executerLotMarge({ file = [], taille = 50, traiter, checkpoint, doitArreter = () => false } = {}) {
  if (typeof traiter !== 'function') throw new Error('Collecteur de marge absent.');
  const lot = selectionnerLotMarge(file, taille);
  const resultats = [];
  for (let index = 0; index < lot.length; index += 1) {
    const commande = lot[index];
    const resultat = await traiter(commande);
    resultats.push(resultat);
    if (typeof checkpoint === 'function') await checkpoint({ resultats: [...resultats], derniereCommande: commande.numero, prochaineCommande: file[index + 1]?.numero || null });
    if (doitArreter()) return { statut: 'INTERROMPUE', resultats, derniereCommande: commande.numero, prochaineCommande: file[index + 1]?.numero || null };
  }
  return { statut: 'TERMINEE', resultats, derniereCommande: lot.at(-1)?.numero || null, prochaineCommande: file[lot.length]?.numero || null };
}
